//
// locale_ru.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/ru.json';
import localeData from "react-intl/locale-data/ru.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
